@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.dynamicroles

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.admin.DynamicRoleDto


object UpsertAdminDynamicRolesEndpoint : EndPoint<UpsertAdminDynamicRolesEndpoint.Request, UpsertAdminDynamicRolesEndpoint.Response>() {
    class Request(
            val item: DynamicRoleDto
    )

    class Response
}

